import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const useQueryParam = (paramName: string): string | null => {
  const location = useLocation();
  const [paramValue, setParamValue] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const valueFromUrl = params.get(paramName);
    setParamValue(valueFromUrl);
  }, [location, paramName]);

  return paramValue;
};

export default useQueryParam;
